module.exports = __webpack_public_path__ + "static/media/SellerboxGuideBlog.6bea190d.png";